import { ETagsActionType } from './types';
import { TTag } from '../../types/tags';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const removeTag = actionGenerator<ETagsActionType.Removed, TTag>(ETagsActionType.Removed);
